import { countries } from "countries-list";

//types
import { Generic } from "types/filters-store.types";

export const countryOptions: Generic[] = Object.entries(countries).map(
  ([key, value]) => ({ value: key, label: `${value.name} (${key})` })
);

// checkbox ids are generated from the value, appending multiselect descriptor to allow for multiple checkboxes with the same value to be displayed at once
export const activityOptions: Generic[] = [
  { value: "activities/manufacturer", label: "Manufacturer" },
  { value: "activities/distributor", label: "Distributor/Agent" },
  { value: "activities/broker", label: "Broker (Intermediary)" },
  { value: "activities/retailer", label: "Retailer" },
  { value: "activities/service", label: "Service(s)" },
  { value: "activities/consultant", label: "Consultant" },
  { value: "activities/financing", label: "Financing" },
  { value: "activities/other", label: "Other" },
];

export const relationshipOptions: Generic[] = [
  { value: "relationships/export", label: "Direct export sales" },
  { value: "relationships/distributor", label: "Distributor/Importer" },
  {
    value: "relationships/Representative",
    label: "Representative/Agent/Broker",
  },
  { value: "relationships/retailer", label: "Overseas retailers" },
  { value: "relationships/licensing", label: "Licensing" },
  { value: "relationships/franchising", label: "Franchising" },
  { value: "relationships/manufacturing", label: "Contract manufacturing" },
  { value: "relationships/joint", label: "Joint venture/coventure" },
  {
    value: "relationships/affiliates",
    label: "Wholly owned subsidiaries/branches",
  },
  { value: "relationships/alliances", label: "Alliances" },
  { value: "relationships/investment", label: "Investment" },
  // { value: "relationships/other", label: "Other" },
];
